import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { notifications } from '@mantine/notifications';

import { ResetPasswordResponse } from '@/features/auth';

export type ResetUserPasswordDTO = {
    data: {
        password: string;
        passwordConfirmation: string;
    };
    token: string;
    user_uuid: string
}

export const resetUserPassword = ({ data, token, user_uuid }: ResetUserPasswordDTO): Promise<ResetPasswordResponse> => {
    return axios.post(`/users/resetpassword/${user_uuid}/${token}`, data);
};

type UseUpdatePasswordUserOptions = {
    config? : MutationConfig<typeof resetUserPassword>;
};

export const useResetPasswordUser = ({ config }: UseUpdatePasswordUserOptions = {}) => {
    return useMutation({
        onMutate: async (resetingUser: any) => {
            await queryClient.cancelQueries(['resetUserPassword']);

            const previousUser = queryClient.getQueryData<Event>([
                'resetUserPassword',
                resetingUser?.user_uuid,
            ]);

            queryClient.setQueryData(['resetUserPassword', resetingUser.user_uuid], {
                ...previousUser,
                ...resetingUser.data,
                uuid: resetingUser.user_uuid,
            });

            return { previousUser };
        },
        onError: (_,__, context: any) => {
            if (context?.previousUser) {
                queryClient.setQueryData(
                    ['resetUserPassword'],
                    context.previousUser
                );
            }
            notifications.show({
                title: 'Error',
                message: 'An error occurred while sending the reset password link ❌',
                color: 'red'
            });
        },
        onSuccess: () => {
            queryClient.refetchQueries(['resetUserPassword']);
            notifications.show({
                title: 'Success!',
                message: 'Reset password link sent ✅',
                color: 'green'
            });
        },
        ...config,
        mutationFn: resetUserPassword
    });
}